import CartUtilitiesReducer, {
    StoreCartUtilitiesActions,
} from "@store/Framework/Store/Store/Data/CartUtilities/CartUtilitiesReducer";
import { combineReducers } from "redux";

const dataReducers = {
    cartUtilities: CartUtilitiesReducer,
};

export type StoreDataActions = StoreCartUtilitiesActions;
export default combineReducers(dataReducers);
